import {Component,Inject} from 'ng-metadata/core';
import {SearchFieldsService} from '../../../search.fields.service';
import {STATE_NAMES} from '../../../../primoExplore/primoExploreStates.module';
import {JournalsService} from "../../../../journals/journals.service";
import {getVid} from "../../../../appConfig/appConfigForward";
import {DatabasesService} from "../../../../journals/databases.service";
import {NewspapersService} from '../../../../newspapers/newspapers.service';
import {SearchService} from '../../../search.service';
import {getDefaultScope, getScopeList, getTab, isNgrs} from '../../../../appConfig/appConfigForward';
import {JwtUtilService} from "../../../../security/jwtUtil.service";
import {UserSessionManagerService} from "../../../../security/userSessionManager.service";
const isArray = require('lodash/isArray');

@Component({
    selector: 'prm-ngrs-results-button',
    templateUrl: 'components/search/fullView/ngrs/resultsButton/ngrs-results-button.html'
})

export class PrmNgrsResultsButton {   
    
    private backToBrowseLabel: string = 'nui.ngrs.backto.btn';
    private scopes = getScopeList();
    private centralIndexScopeId;
    private centralIndexTab;
    private showRapidoBlankFormLink: boolean;

    constructor(@Inject('$stateParams')  private $stateParams:ng.ui.IStateParamsService,
                @Inject('$state') private $state: ng.ui.IStateService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                private searchService: SearchService,
                private searchFieldsService: SearchFieldsService,
                private journalsService: JournalsService,
                private databasesService: DatabasesService,
                private newspapersService : NewspapersService,
                private jwtUtilService: JwtUtilService,
                private userSessionManagerService: UserSessionManagerService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService) {
    }

    ngOnInit() {
        let searchObject = this.searchService.getSearchObject();
        let searchObjectScopeTab = searchObject.tab;
        let searchObjectScopeId = searchObject.scope;
        let isCentralIndexScope = !!window.appConfig['primo-view']['pc-availability-tab-scopes-map'][searchObjectScopeTab]
            && window.appConfig['primo-view']['pc-availability-tab-scopes-map'][searchObjectScopeTab][searchObjectScopeId] 
            && window.appConfig['primo-view']['pc-availability-tab-scopes-map'][searchObjectScopeTab][searchObjectScopeId] !== 'AVAILABLE_ONLY';
        
        if(isCentralIndexScope){
            this.centralIndexTab = searchObjectScopeTab;
            this.centralIndexScopeId = searchObjectScopeId;
        } else {          
            let scopeOptions = getScopeList();
            for (let i = 0; i < scopeOptions.length; i++) {
                if (scopeOptions[i]["contains-central-index-scope"] === true) {
                    let scopeTab = scopeOptions[i]["tab"];
                    let scopeId = scopeOptions[i]["scope-id"];
                    let availableOnly = window.appConfig['primo-view']['pc-availability-tab-scopes-map'][scopeTab][scopeId];
                    if (availableOnly !== 'AVAILABLE_ONLY') {
                        this.centralIndexTab = scopeTab;
                        this.centralIndexScopeId = scopeId;
                        break;
                    }
                }
            }
        }
        this.showRapidoBlankFormLink = !this.hideRapidoBlankFormLinkBasedOnUserGroup();
    }

    changeSearchScope(){   
        let state = STATE_NAMES.SEARCH;
        this.searchFieldsService.searchParams.search_scope = this.centralIndexScopeId;
        this.searchFieldsService.searchParams.tab = this.centralIndexTab;
        this.setSearchParams();
        this.$state.go(state, this.searchFieldsService.searchParams , {reload: false});
    }

    private setSearchParams() {
        let searchParams = this.searchFieldsService.searchParams.query;
        if (searchParams) {
            let fixSlashChar = (s) => {
                return s.replace ? s.replace(/~2F/g, '/') : s;
            }
            if (isArray(searchParams)) {
                this.searchFieldsService.searchParams.query = searchParams.map(fixSlashChar);
            } else {
                this.searchFieldsService.searchParams.query = fixSlashChar(searchParams);
            }
        }
    }
    
    getBlankFormPage(){
        let state = STATE_NAMES.BLANK_ILL;
        this.$state.go(state,{'vid' : getVid()},{reload: false});	
    }

    isRapidoExpandRequired() {
        if (isNgrs() && !this.isBrowseMode) {        
            let searchObject = this.searchService.getSearchObject();
            let slotMap = window.appConfig['system-configuration'].hide_rapido_expand_link_map;
            let hideRapidoExpandLink = false;
            for (let slot in slotMap){
                if (slot == searchObject.tab){
                    hideRapidoExpandLink = slotMap[slot];
                }
            }
            return (searchObject.tab != this.centralIndexTab || searchObject.scope != this.centralIndexScopeId) && !hideRapidoExpandLink && searchObject.tab != "jsearch_slot";
        }
        return false;
    }
    
    private navigateBackToSearchResults(){
        let state = STATE_NAMES.SEARCH;
        this.searchFieldsService.searchParams.search_scope = getDefaultScope();
        this.searchFieldsService.searchParams.tab = getTab(getDefaultScope());
        this.setSearchParams();
        this.$state.go(state, this.searchFieldsService.searchParams , {reload: false});
    }

    private isRapidoLinksTileRequired(){
        return this.isRapidoExpandRequired() || this.isBackToSearchRequired() || (this.isStillNotFoundRequired() && this.showRapidoBlankFormLink) ;
    }

    private isBackToSearchRequired(){
        let searchObject = this.searchService.getSearchObject();
        return searchObject.tab == this.centralIndexTab && searchObject.scope == this.centralIndexScopeId 
            && ((getTab(getDefaultScope()) !== searchObject.tab) || (getDefaultScope() !== searchObject.scope));
    }

    private isStillNotFoundRequired(){
        let searchObject = this.searchService.getSearchObject();
        return searchObject.tab == this.centralIndexTab && searchObject.scope == this.centralIndexScopeId;
    }

    private hideRapidoBlankFormLinkBasedOnUserGroup(){
        let hideWhenNotLoggedIn = window.appConfig['system-configuration'].rapido_hide_blank_form_link_when_user_not_logged_in;
        let userGroupsToHideFrom = window.appConfig['system-configuration'].rapido_hide_blank_form_link_user_groups;
        let currentUserGroup = this.jwtUtilService.getDecodedToken().userGroup ? this.jwtUtilService.getDecodedToken().userGroup.toUpperCase() : undefined;
        let isGuestUser = !this.userSessionManagerService.getUserName();
        if(isGuestUser){
            return hideWhenNotLoggedIn;
        }
        const groups: string[] = Object.keys(userGroupsToHideFrom).map(key => userGroupsToHideFrom[key].toUpperCase());

        return groups.indexOf(currentUserGroup) !== -1;    }

    private isBackToSearchRequiredAndShowRapidoBlankFormLink(){
        return this.isBackToSearchRequired() && this.showRapidoBlankFormLink;
    }

    private isStillNotFoundRequiredAndShowRapidoBlankFormLink(){
        return this.isStillNotFoundRequired() && this.showRapidoBlankFormLink;
    }

    get isBrowseMode(){
        return this.$stateParams['mode'] === 'browse';
    }

    get browseScope(){
        return this.$stateParams['browseScope'];
    }

    get browseState(){
        return STATE_NAMES.BROWSE_SEARCH;
    }

    get backToBrowseParams(){
        return {
            vid: getVid(),
            browseQuery: this.$stateParams['browseQuery'],
            browseScope: this.$stateParams['browseScope'],
            browseFirstTerm: this.$stateParams['browseFirstTerm'],
            innerPnxIndex: this.$stateParams['innerPnxIndex'],
            numOfUsedTerms: this.$stateParams['numOfUsedTerms'],
            fn: this.$stateParams['fn'],

        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/resultsButton/ngrsResultsButton.directive.ts